module.exports = __webpack_public_path__ + "static/media/Logo.4a951f8d.svg";